module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-2",
      "lang": "en-US"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It turned out to be the most exciting hockey game I had seen in years. The New York Rangers trailed almost from the opening face-off, eventually falling behind by three goals. Then they fought back, improbably scoring twice in the final three minutes to defeat Toronto, the team that would go on to win the Stanley Cup during that post–World War II season.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The sold-out arena erupted—everyone, that is, except Lily Rowan, who seemed to be elsewhere. As we made our way out of Madison Square Garden with the still-excited crowd and headed for a bar down the street, Lily confirmed what I had felt all evening: her mind was far from the ice rink. After we had settled into a quiet booth at the rear of the bar, I turned to her.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“My dear, you have been worlds away tonight. First at Rusterman’s, where you seemed to find little joy in the superb veal cutlets, normally a favorite of yours. Then at the game, where you are usually among the most enthusiastic fans in the Garden, you sat on your hands, despite how exciting the action on the ice was. Care to unburden yourself to your old uncle Archie?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Uncle Archie, is it now?” she said. “Funny, I have never thought of our relationship as uncle and niece.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Okay, neither have I, obviously. It was just my feeble attempt at humor, which clearly didn’t strike home, judging by your expression. Seriously, what is bothering you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, Escamillo, you know how I hate to burden you with my problems. You always have so many challenges of your own, trying to help Nero Wolfe solve his cases.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“"), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("Trying")]), _vm._v(" "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("to help")]), _vm._v(" is the operative phrase, I’m afraid. You know very well that Wolfe does all the solving, while I am just his spear-carrier. But let us get back to you. Why the glum expression tonight?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lily let out an extended sigh. “You have met Maureen Carr, and more than once.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I have indeed, and what an adorable creature she is, as well as brainy and charming. Mark me down as impressed.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I can’t quarrel with your assessment. And she has been among my best friends over the years. However, something has happened …”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Go on.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“As you know, two weekends ago, I was at my place up in Katonah with our women’s group, a dozen or so of us meeting as we do for three or four days every March to talk about projects we are working on. Maureen was supposed to be there, as usual, but she never showed up, and in the days since, she hasn’t answered her phone to me or anyone else, and not one of her friends has heard from her, which is highly unusual. All of us are very concerned.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Here, I must break into the narrative to tell you about Lily Rowan. She is my good—make that "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("very")]), _vm._v(" good—friend, and I have known her since that day years ago when, on a job with Nero Wolfe in rural Upstate New York, a bull charged at me in a field, and I leaped over a fence to avoid him, landing on my rear end and losing my dignity in the process.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A lovely young woman in a yellow shirt and slacks leaned on the fence and clapped her hands, saying “Beautiful, Escamillo! Do it again!” That was Lily. And Escamillo, a name she has tagged me with ever since, is a toreador in the opera "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("Carmen")]), _vm._v("."), _c('span', {
    attrs: {
      "id": "footnote-000-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/MissingHeiress2#footnote-000"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lily is very rich, having inherited millions from her father, an Irish immigrant who built much of New York City’s current sewer system. She also is lazy, by her own definition, although I strongly dispute that definition. She does not have—or need—a salaried job, but she is actively involved in numerous good works, to which she gives unstintingly both of her time and her funds.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And that “women’s group” to which she referred is not some gathering of idle dilettantes, but rather a loose-knit organization of volunteers committed to the financing and the betterment of orphanages, food pantries, havens for battered wives, and improved working conditions for women, among other projects. Their annual meetings at Lily’s Katonah estate north of New York are to compare notes and plan strategies for the year ahead.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lily lives in a spacious duplex penthouse in Midtown Manhattan, where she throws lavish parties, many of them benefiting one or more of the causes she supports. I often serve as a bartender at these soirees. When she is not involved in good works, Lily and I can be seen at hockey or baseball games, the opera or a Broadway play, or dancing at the Hotel Churchill. And just to keep things straight, when she and I are out on the town, I foot the bill. Now, back to that bar near Madison Square Garden. ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Tell me more about Maureen,” I asked as we were served our drinks.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“She is within a year or two of my age and has been divorced for, oh … probably eight years now. She got a good settlement, so she says, although she has money of her own from an inheritance. Her late father ran a steel company in Pennsylvania and put her through Radcliffe, where she got a degree.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Was her breakup amicable?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lily lifted her shoulders and let them drop slowly. “I suppose you could say that. Her ex-husband, Larry Corcoran, whom I don’t believe you ever met, has remarried. His flirtation with the woman who eventually became his second wife probably was the reason for Maureen’s breakup with him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Uh-huh. An age-old story. How long has it been since any of your group has been in touch with her?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Probably more than two weeks now, at least as far as I know. Among us, we have been talking a lot about Maureen, and we all are totally puzzled—and worried.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well, there’s no question that she’s got plenty of green stuff. Maybe she took off for a warmer climate—the Caribbean, Hawaii, or maybe even the South of France.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Not likely, not at all,” Lily said, “and unlike the rest of us, she does not have a vacation home she can go to. Something serious must have happened. Maureen has never before missed one of our Katonah gatherings, and if she’s ever had to cancel for some reason, she lets me know. She is extremely responsible and conscientious.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What about relatives? She must have some. Maybe she’s gone to stay with one of them. Perhaps there has been some sort of family emergency that she’s gone to help out with.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“For one thing, Maureen is almost an only child, and both her parents are long dead. It’s a situation not different from my own. And now that I think about it, I don’t ever recall her talking about any aunts, uncles, cousins.” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What do you mean by "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("almost ")]), _vm._v("an only child?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Sorry, I did not phrase that well. Maureen does have a half brother, Everett, whom I have never met. They are not at all close, and in all the time I have known her, she has barely mentioned him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Bad blood?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I don’t think so. It’s more a case of having little or nothing in common. From what little I have been able to learn, Everett is quite a bit older than Maureen and is the son of her father and his first wife.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Any idea where Everett lives?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lily bit her lower lip, as if in thought. “I think she once said something about him being in the New York area, but she was pretty vague, perhaps on purpose. Or maybe she didn’t know. She seems to feel that he has led something of an aimless life.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Hmm. I assume that as an offspring of a steel baron, he ended up with at least a healthy chunk of his father’s estate.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I agree with your assumption. The only other thing I remember Maureen mentioning about him was that he tended to be careless with money.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Those who have it don’t always use it well,” I remarked.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That might well be the case with this prodigal brother,” Lily said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I should know where Maureen lives, although I’m not sure if you have ever mentioned it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I may not have. She has a duplex on Park Avenue up in the Sixties. It’s a lavish place.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Given your own abode, the fact that you call another apartment ‘lavish’ gets my attention.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I am not exaggerating, Archie. It is a showpiece.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Have you or any other friends of Miss Carr been at that ‘showpiece’ since she dropped out of sight?” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Not that I’m aware of, although I did get the telephone number of her maid, Sofia, and called her at home. She sounded baffled as to where Maureen might have gone. ‘Miss Carr said nothing to me about going away, Miss Rowan. I do not know what to think,’ Sofia told me.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You know I don’t like to be a busybody; it is not my style and never has been,” Lily said. “But darn it, Archie, I just can’t figure out what to do, and I know something has got to be wrong.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When she refers to me as “Archie” rather than that operatic bullfighter, as she has during this conversation, I know that she’s really upset and is indirectly asking for help. “Can I assume this Sofia has a key to Maureen’s Park Avenue duplex?” I posed.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“She must,” Lily said, “because even when Maureen is out of town, she goes there to dust and make sure things are in order for her employer’s return. Are you suggesting we should get the key and take a look around?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“As usual, you read me like a book,” I said. “Do you also know where the maid lives?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Up in Morningside Heights, somewhere just off Broadway, I think. Maureen mentioned it once.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Do you know Sofia’s last name?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I don’t, but maybe one of the other girls in our group does. We have all been up to Maureen’s, of course, for parties and meetings, and Sofia has often been there, serving us drinks and food. I’ll ask around. You think we should go to the duplex and take a look, don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Don’t you?” I countered.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lily frowned. “I … well, I guess so.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You seem unsure.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Somehow, I would feel like a snoop going through Maureen’s home.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Now you know how I feel when I’m searching somebody’s place.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“But that doesn’t really make you a snoop, at least by my definition. You are at work as a private detective, which is an honorable profession.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Tell that to our old friend Inspector Cramer sometime and be prepared for a horse laugh. Look, you have already told me how worried you are about Maureen Carr. I think that overrides any feelings you might have about being a nosy parker.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“All right, I see your point. As you so often like to say, ‘I am on the case.’ I’ll call Sofia again, and see if we can get a key to Maureen’s place from her.” ")]), _vm._v(" "), _c('hr', {
    staticClass: "HorizontalRule-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "_idFootnotes"
  }, [_c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "epub:type": "footnote",
      "id": "footnote-000"
    }
  }, [_c('p', {
    staticClass: "Footnote ParaOverride-3",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/MissingHeiress2#footnote-000-backlink"
    }
  }, [_vm._v("*")]), _vm._v("  From "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("Some Buried Caesar")]), _vm._v(" by Rex Stout (1939)")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3033cd17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MissingHeiress2.vue
// module id = 78
// module chunks = 0